import { render } from "./SitemapCreation.vue?vue&type=template&id=e8039ea4"
import script from "./SitemapCreation.vue?vue&type=script&lang=js"
export * from "./SitemapCreation.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__